
import { Section } from "../types";

export interface SectionTemplate {
  id: string;
  title: string;
  description: string;
  category: 'hero' | 'features' | 'content' | 'testimonials' | 'pricing' | 'contact';
  thumbnail: string;
  blocks: any[];
  isPro?: boolean;
  createdBy?: string;
  createdAt?: string;
}

export interface FunnelTemplate {
  id: string;
  title: string;
  description: string;
  thumbnail: string;
  isPro?: boolean;
  createdBy?: string;
  createdAt?: string;
  data: any;
  version?: string;
}

export const sectionTemplates: SectionTemplate[] = [
  {
    id: 'hero-1',
    title: 'Hero Section',
    description: 'A bold hero section with heading, subtext, and call-to-action',
    category: 'hero',
    thumbnail: '/templates/hero-1.jpg',
    blocks: [
      {
        id: crypto.randomUUID(),
        type: 'image',
        content: '/placeholder.jpg',
      },
      {
        id: crypto.randomUUID(),
        type: 'text',
        content: '<h1>Welcome to Our Platform</h1>',
        alignment: 'center',
      },
      {
        id: crypto.randomUUID(),
        type: 'text',
        content: '<p>Transform your business with our powerful solutions</p>',
        alignment: 'center',
      },
      {
        id: crypto.randomUUID(),
        type: 'form',
      }
    ]
  },
  {
    id: 'usp-1',
    title: 'USP Grid',
    description: 'Display your unique value propositions',
    category: 'features',
    thumbnail: '/templates/usp-1.jpg',
    blocks: [
      {
        id: crypto.randomUUID(),
        type: 'text',
        content: '<h2>Why Choose Us</h2>',
        alignment: 'center',
      },
      {
        id: crypto.randomUUID(),
        type: 'feature-grid',
        content: JSON.stringify({
          features: [
            { title: 'Feature 1', description: 'Description here' },
            { title: 'Feature 2', description: 'Description here' },
            { title: 'Feature 3', description: 'Description here' }
          ]
        })
      }
    ]
  },
  {
    id: 'product-1',
    title: 'Product Showcase',
    description: 'Showcase your product or service',
    category: 'content',
    thumbnail: '/templates/product-1.jpg',
    blocks: [
      {
        id: crypto.randomUUID(),
        type: 'image',
        content: '/placeholder.jpg',
      },
      {
        id: crypto.randomUUID(),
        type: 'text',
        content: '<h2>Our Product</h2><ul><li>Benefit 1</li><li>Benefit 2</li><li>Benefit 3</li></ul>',
      },
      {
        id: crypto.randomUUID(),
        type: 'button',
        content: 'Learn More',
        theme: 'primary',
      }
    ]
  },
  {
    id: 'testimonials-1',
    title: 'Testimonials',
    description: 'Display customer testimonials and social proof',
    category: 'testimonials',
    thumbnail: '/templates/testimonials-1.jpg',
    blocks: [
      {
        id: crypto.randomUUID(),
        type: 'posts',
        content: 'testimonials',
      }
    ]
  },
  {
    id: 'pricing-1',
    title: 'Pricing Section',
    description: 'Show your pricing plans',
    category: 'pricing',
    thumbnail: '/templates/pricing-1.jpg',
    blocks: [
      {
        id: crypto.randomUUID(),
        type: 'text',
        content: '<h2>Our Pricing</h2>',
        alignment: 'center',
      },
      {
        id: crypto.randomUUID(),
        type: 'embed',
        content: '<div class="pricing-table">...</div>',
      }
    ]
  },
  {
    id: 'blog-1',
    title: 'Blog Section',
    description: 'Display your latest blog posts',
    category: 'content',
    thumbnail: '/templates/blog-1.jpg',
    blocks: [
      {
        id: crypto.randomUUID(),
        type: 'posts',
        content: 'blog',
      }
    ]
  },
  {
    id: 'contact-1',
    title: 'Contact Section',
    description: 'Add contact form and information',
    category: 'contact',
    thumbnail: '/templates/contact-1.jpg',
    blocks: [
      {
        id: crypto.randomUUID(),
        type: 'form',
      },
      {
        id: crypto.randomUUID(),
        type: 'embed',
        content: '<iframe src="https://www.google.com/maps/embed?..." width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe>',
      }
    ]
  }
];
